import { JobFinanceGetRequest } from '@trukt/tms-api/JobFinanceService';
import { createKey } from '../../createKey';

const keyHandler = createKey('job-finance');

export const JobFinanceServiceKeys = {
  key: keyHandler.key,
  get: keyHandler.createMethod<JobFinanceGetRequest>(),
};
